import React, { ComponentProps } from 'react';
import { asFetchableView } from '../../../_lib/ViewFetcher';
import { TicketAccordion, TicketsByDate } from '../partials/TicketAccordion';

type TicketBookingDefaultProps = {
  ticketsOfDate: TicketsByDate[];
};

function TicketBookingDefault(props: TicketBookingDefaultProps) {
  return <TicketAccordion {...props} />;
}

export const TicketBookingDefaultView = asFetchableView(TicketBookingDefault);
export type TicketBookingDefaultView = ComponentProps<typeof TicketBookingDefaultView>;
